import styled from '@emotion/styled'
// import React from 'react'; 

const BigCaslonBold = styled.div`
    font-family: Big Caslon;
    font-weight: bold;
` 

export default BigCaslonBold;